import { useCallback } from 'react';

const useClipboardCopy = () => {
  return useCallback(text => {
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      // iOS workaround referenced from https://josephkhan.me/javascript-copy-clipboard-safari/
      const textArea = document.createElement('textArea');
      textArea.readOnly = true;
      textArea.contentEditable = true;
      textArea.value = text;
      document.body.appendChild(textArea);
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
      document.execCommand('copy');
      document.body.removeChild(textArea);
    } else {
      navigator.clipboard.writeText(text);
    }
  }, []);
};

export default useClipboardCopy;
